import * as echarts from 'echarts/core';
import {BarChart, LineChart, PieChart, GaugeChart, HeatmapChart, ScatterChart, FunnelChart, TreemapChart, RadarChart} from 'echarts/charts';
import {
  GridComponent, TooltipComponent, LegendComponent, TitleComponent, ToolboxComponent,
  DataZoomComponent, VisualMapComponent, AriaComponent, RadarComponent, MarkLineComponent, GraphicComponent
} from 'echarts/components';
import {CanvasRenderer} from 'echarts/renderers';

echarts.use([
  BarChart, LineChart, PieChart, GaugeChart, HeatmapChart, ScatterChart, FunnelChart, TreemapChart, RadarChart,
  GridComponent, TooltipComponent, LegendComponent, TitleComponent, ToolboxComponent,
  DataZoomComponent, VisualMapComponent, AriaComponent, RadarComponent, MarkLineComponent, GraphicComponent,
  CanvasRenderer,
]);

export {echarts};
